import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';
/* import gethomeSection  from '~/components/czar/homeFeaturedProducts/homeFeaturedProducts.gql' */
import getrouteCheck from '~/components/czar/homePage/routeCheck.gql';
import { useApi } from '~/composables/useApi';

type checkRouterData = {
    routerDataRes: {}
};

export const usefetchRouterCheck = defineStore('checkRouterData', () => {
  const { query } = useApi();
  const routerDataRes = ref<any | null>(null);  

  const fetchRouterCheck = async (queryVariables: any) => {
    const response = await query<checkRouterData>(getrouteCheck, queryVariables);
    routerDataRes.value = response?.data;
  };
  return {
    routerDataRes,
    fetchRouterCheck
  }
});
export default usefetchRouterCheck;
/*  */





/* 
type routeData = {
    routeValue : {}
};

export const userouteCheck = () => {
    const { query } = useApi();
    const routeValue = ref<any | null>(null);  

    query<routeData>(getrouteCheck).then((response) => {
        routeValue.value = response.data;
    });

    return {
        routeValue
    };
}

export default userouteCheck; */